import { Component } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
@Component({
  selector: 'app-login-navbar',
  imports: [],
  templateUrl: './login-navbar.html',
  styleUrl: './login-navbar.css',
})
export class LoginNavbar {
  constructor(private router: Router) {}
  goBack() {
    this.router.navigate(['/']);
  }
}
